import { useClientBranding } from '~/hooks/useClientBranding';

const UNBOARED_PICTO = '/assets/images/logo-unboared-sm-tr.png';

/**
 * Logo en tête des écrans du téléphone : celui de l'établissement en formule Pro,
 * sinon le picto Unboared. Même classe CSS dans les deux cas : la place réservée
 * par l'écran ne change pas (le logo de marque est contenu dedans).
 */
export function BrandLogo({ clientID, className }: { clientID: string | null | undefined; className?: string }) {
    const branding = useClientBranding(clientID);
    if (branding?.logo) {
        return (
            <img
                className={className}
                src={branding.logo}
                alt=""
                style={{ objectFit: 'contain', width: 'auto', maxWidth: 140 }}
            />
        );
    }
    return <img className={className} src={UNBOARED_PICTO} alt="Unboared" />;
}
